import { Component, Vue, Watch } from 'vue-property-decorator';
import { ToastProgrammatic as Toast } from 'buefy';
import { isTruthy, isDifferent } from '@/jbi-shared/util/watcher.vue-decorator';
import { Throttle } from '@/jbi-shared/util/throttle.vue-decorator';
import { RootState } from '@/store/store';
import { Action, State } from 'vuex-class';
import { ResearchNode } from '@/store/modules/documents/types/documents.types';
import { UpdateProjectSettingsPayload } from '@/store/modules/pending-documents/pending-documents.actions';

export interface EditPendingProjectFormValues {
  projectTitle: string;
  primaryResearchNode: ResearchNode | undefined;
  researchNodes: ResearchNode[];
}

@Component({})
export class UpdatePendingProjectMixin extends Vue {
  @Action('pendingDocuments/updatePendingProjectSettings')
  public updatePendingProjectSettingsAction!: (
    payload: UpdateProjectSettingsPayload
  ) => void;

  @State(
    (state: RootState) =>
      state.pendingDocuments.apiState.updateProjectSettings.success
  )
  public updateProjectSettingsSuccess!: boolean;

  @State(
    (state: RootState) =>
      state.pendingDocuments.apiState.updateProjectSettings.error
  )
  public updateProjectSettingsError!: any;

  @Watch('updateProjectSettingsSuccess')
  @isDifferent
  @isTruthy
  @Throttle(500)
  public onUpdateProjectSettingsSuccess() {
    Toast.open({
      message: `Project Successfully Updated`,
      position: 'is-top',
      type: 'is-dark'
    });
  }

  @Watch('updateProjectSettingsError')
  @isDifferent
  @isTruthy
  @Throttle(500)
  public onUpdateProjectSettingsError() {
    Toast.open({
      message: `Failed to update project settings. Please try again!`,
      position: 'is-top',
      type: 'is-danger'
    });
  }

  public editPendingProject(
    values: EditPendingProjectFormValues & { pendingDocumentId: number }
  ) {
    const {
      projectTitle,
      primaryResearchNode,
      researchNodes,
      pendingDocumentId
    } = values;

    this.updatePendingProjectSettingsAction({
      pendingDocumentId,
      projectTitle,
      primaryResearchNodeId: primaryResearchNode?.id || undefined,
      researchNodeIds: researchNodes.map((node: ResearchNode) => node.id)
    });
  }
}
